import React, { useEffect, useMemo } from 'react';
import { Vector3 } from 'three';

import { SvgVisual } from './SvgVisual';

interface Props {
  iconName: string;
  rotation: number;
  size: number;
  position?: Vector3;
}

export const R3FSvgVisual = ({ iconName, rotation, size, position = new Vector3() }: Props) => {
  const object = useMemo(() => new SvgVisual({ iconName, rotation, size }), [iconName, rotation, size]);
  useEffect(() => () => object.dispose(), [object]);
  useEffect(() => void object.position.copy(position), [object, position]);
  return <primitive object={object} />;
};
